// 카카오 픽셀 ID
const KAKAO_PIXEL_ID = "5584288922218968589";

// 카카오 픽셀 인스턴스 생성 및 export
// index.html에서 스크립트가 로드되므로 바로 사용 가능
const kakaoPixel = 
  typeof window !== "undefined" && window.kakaoPixel
    ? window.kakaoPixel(KAKAO_PIXEL_ID)
    : null;

export default kakaoPixel;

